window.PhotoSwipe = require("photoswipe")
window.PhotoSwipeUI_Default = require("photoswipe/dist/photoswipe-ui-default")
require("malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min")
require("lodash")
